import { render, staticRenderFns } from "./EFDReceipts.vue?vue&type=template&id=e4b78be2&"
import script from "./EFDReceipts.vue?vue&type=script&lang=js&"
export * from "./EFDReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports